// VH-317: after HubPlatform the server sends the browser to
// `/login#hubplatform=<result>&handoff=…` or `/security#hubplatform=<result>`.
// Both come after `#`, which a browser never sends to a server.

export const HUBPLATFORM_RESULT = {
  SIGNED_IN: 'signed_in',
  CODE: 'code',
  NOT_LINKED: 'not_linked',
  LINKED: 'linked',
  TAKEN: 'taken',
  UNREACHABLE: 'unreachable',
  REFUSED: 'refused',
}

const KNOWN = new Set(Object.values(HUBPLATFORM_RESULT))

/** { result, handoff } from the `#` part, or null when it is not HubPlatform's. */
export function readHubPlatformLanding(hash) {
  const params = new URLSearchParams((hash || '').replace(/^#/, ''))
  const result = params.get('hubplatform')
  if (!result) return null
  return {
    result: KNOWN.has(result) ? result : HUBPLATFORM_RESULT.REFUSED,
    handoff: params.get('handoff') || null,
  }
}
